<template>
  <div class="message-menu-wrapper">
    <ul class="message-menu">
      <li class="comment-msg" @click="switchCommentMsg">
        <span class="menu-tip">评论</span>
      </li>
      <li class="notice-msg" @click="switchNoticeMsg">
        <span class="menu-tip">通知</span>
      </li>
      <li class="contact-msg" @click="switchContactMsg">
        <span class="menu-tip">联系</span>
      </li>
    </ul>
    <div class="comment-msg-container">
      <el-dialog
        title="评论消息"
        :visible.sync="commentVisible"
        custom-class="handlian-comment-container"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="820px"
      >
        <div class="comment-msg-wrap">
          <!-- 评论列表 -->
          <CommentCell
            v-for="(comment, index) in commentList"
            :key="index"
            :comment="comment"
          />
          <div
            class="comment-msg-loading"
            v-loading="commentShade"
            v-if="commentList.length == 0"
          >
            <span class="no-msg" v-if="!commentShade">暂无消息</span>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="notice-msg-container">
      <el-dialog
        title="通知消息"
        :visible.sync="noticeVisible"
        custom-class="handlian-inform-container"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="820px"
      >
        <div class="notice-msg-wrapper">
          <AdminNoticeCell
            v-for="(notice, index) in adminNotice"
            :key="index"
            :notice="notice"
          />
          <div class="no-syt-notice" v-if="adminNotice.length == 0">
            <span class="no-msg">暂无消息</span>
          </div>
          <!-- <el-tabs :tab-position="tabPosition">
                        <el-tab-pane label="系统通知">
                            <div class="admin-msg-container">
                                <AdminNoticeCell
                                    v-for="(notice,index) in adminNotice"
                                    :key="index"
                                    :notice="notice"
                                />
                                <div class="no-syt-notice" v-if="adminNotice.length==0">
                                    <span class="no-msg">暂无消息</span>
                                </div>
                            </div>                            
                        </el-tab-pane>
                        <el-tab-pane label="传连通知">
                            <div class="hl-apply-container">
                                <HandLianCell
                                    v-for="(apply) in handLianApply"
                                    :key="apply.id"
                                    :apply="apply"
                                />
                                <CopyTreeCell
                                    v-for="(item) in copyTreeApply"
                                    :key="item.id"
                                    :apply="item"
                                />                    
                                <div class="no-hl-apply" v-if="handLianApply.length==0 && copyTreeApply.length==0">
                                    <span class="no-msg">暂无消息</span>
                                </div>
                            </div>
                        </el-tab-pane>
          </el-tabs>-->
        </div>
      </el-dialog>
    </div>
    <div class="chat-msg-container">
      <el-dialog
        title="聊天消息"
        :visible.sync="contactVisible"
        custom-class="handlian-inform-container"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="820px"
      >
        <div class="chat-msg-wrapper">
          <el-container>
            <el-aside width="200px">
              <div class="conversation-container">
                <ConversationCell
                  v-for="(item, index) in conversationList"
                  :key="index"
                  :conversation="item"
                  @handClick="sessionClick"
                />
              </div>
            </el-aside>
            <el-main>
              <CurrentChat />
            </el-main>
          </el-container>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { apiMap } from "../../utils/apiMap";
import CommentCell from "../CommentNotice";
import AdminNoticeCell from "../AdminNotice";
import HandLianCell from "../HandLianApply";
import CopyTreeCell from "../CopyTreeApply";
import ImagePreviewer from "../message/image-previewer";
// import MessageItem from "../message/message-item";
import ConversationCell from "./conversation-item";
// import MessageSendBox from "../message/message-send-box";
import CurrentChat from "./current-chat";
export default {
  name: "message-menu",
  data() {
    return {
      commentVisible: false,
      noticeVisible: false,
      contactVisible: false,
      commentMsgList: [],
      commentShade: true,
      tabPosition: "left",
    };
  },
  components: {
    CommentCell,
    CopyTreeCell,
    AdminNoticeCell,
    HandLianCell,
    ImagePreviewer,
    ConversationCell,
    CurrentChat,
  },
  computed: {
    ...mapGetters([
      "conversationList",
      "currentConversation",
      "contactsList",
      "copyTreeApply",
      "croupsList",
      "commentList",
      "adminNotice",
      "handLianApply",
    ]),
    ...mapState({
      currentMessageList: (state) => state.currentConversation.messageList,
      currentConversation: (state) => state.currentConversation,
      isCompleted: (state) => state.currentConversation.isCompleted,
      chatUser: (state) => state.currentChat,
    }),
    showMessageSendBox() {
      return this.currentConversation.type !== this.TIM.TYPES.CONV_SYSTEM;
    },
  },
  mounted() {
    this.$bus.$on("close-chat-dialog", this.closeChatDialog);
  },
  methods: {
    switchCommentMsg() {
      if (this.commentVisible == false) {
        this.getCommentMessage(1, 20);
        this.commentVisible = true;
      } else {
        this.commentVisible = false;
      }
    },
    switchNoticeMsg() {
      if (this.noticeVisible == false) {
        // this.getHandLianApply();
        // this.getCopyList(1);//别人向我申请
        // this.getCopyList(2);//我向别人申请
        this.noticeVisible = true;
      } else {
        this.noticeVisible = false;
      }
    },
    switchContactMsg() {
      if (this.contactVisible == false) {
        if (this.conversationList[0]) {
          this.initWidthConversation(this.conversationList[0], (res) => {
            this.contactVisible = true;
          });
        }
        if (this.conversationList.length == 0) {
          this.$message({
            message: "暂无聊天消息",
            duration: 1500,
            offset: 230,
          });
        }
      } else {
        this.contactVisible = false;
      }
    },
    getCommentMessage(start, count) {
      let $this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["communityNews"]["method"],
          url: apiMap["communityNews"]["url"],
          data: "token=" + loginUser.token + "&start=" + start + "&count=count",
        })
        .then(function(response) {
          $this.commentShade = false;
          if (response.data.result.statusCode == 1) {
            let newList = response.data.result.data.filter((item) => {
              return (
                item.comment !== "praise" &&
                item.commentPraiseUserId !== item.publisherUserId
              );
            });
            // newList.sort((a,b)=>{
            //   return b.commentPraiseDate - a.commentPraiseDate
            // });
            // cb(newList);
            $this.commentShade = false;
            Store.dispatch("pushCommentList", newList);
          } else {
            $this.$message({
              message: "暂无通知消息",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getHandLianApply() {
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["applyList"]["method"],
        url: apiMap["applyList"]["url"],
        params: {
          token: loginUser.token,
        },
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            Store.dispatch("pushHandLianAppy", response.data.result.data);
            // let newList = response.data.result.data;
            // newList.forEach(item=>{
            //   if (!item.relationUserInfo.headImgUrl) {
            //      item.relationUserInfo.headImgUrl = Store.state.defaultAvatar.C2C;
            //   }
            // });
            // console.log(newList)
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initWidthConversation(friend, cb) {
      let targetUser = {
        selType: friend.type,
        selToID: friend.userId,
        selToName: friend.name,
        selToAvatar: friend.avatar,
        sessionID: friend.sessionId,
      };
      this.currentChat = targetUser;
      this.$store.dispatch("setCurrentChat", targetUser);
      if (friend.type === TIM.TYPES.CONV_GROUP) {
        this.getGroupMemberList(friend.userId);
      }
      let promise = tim.getMessageList({
        conversationID: friend.sessionId,
        count: 15,
      });
      promise.then(function(imResponse) {
        const messageList = imResponse.data.messageList; // 消息列表。
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        // console.log(nextReqMessageID);
        // console.log(isCompleted);
        let curConversation = {
          messageList: messageList,
          type: friend.type,
          userProfile: {
            avatar: friend.avatar,
            userId: friend.userId,
            userName: friend.name,
          },
          conversationID: friend.sessionId,
          nextReqMessageID: nextReqMessageID,
          isCompleted: isCompleted,
          scrollBottom: true,
        };
        Store.dispatch("setCurrentConversation", curConversation);
        Store.dispatch("clearCurrentUnread", friend.sessionId);
        cb();
      });
    },
    sessionClick(friend) {
      let targetUser = {
        selType: friend.type,
        selToID: friend.userId,
        selToName: friend.name,
        selToAvatar: friend.avatar,
        sessionID: friend.sessionId,
      };
      this.currentChat = targetUser;
      this.$store.dispatch("setCurrentChat", targetUser);
      if (friend.type === TIM.TYPES.CONV_GROUP) {
        this.getGroupMemberList(friend.userId);
      }
      this.getMessageList(friend);
      this.setMessageRead();
    },
    getMessageList(contact) {
      let promise = tim.getMessageList({
        conversationID: contact.sessionId,
        count: 15,
      });
      promise.then(function(imResponse) {
        const messageList = imResponse.data.messageList; // 消息列表。
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        // console.log(nextReqMessageID);
        // console.log(isCompleted);
        let curConversation = {
          messageList: messageList,
          type: contact.type,
          userProfile: {
            avatar: contact.avatar,
            userId: contact.userId,
            userName: contact.name,
          },
          conversationID: contact.sessionId,
          nextReqMessageID: nextReqMessageID,
          isCompleted: isCompleted,
          scrollBottom: true,
        };
        Store.dispatch("setCurrentConversation", curConversation);
        Store.dispatch("clearCurrentUnread", contact.sessionId);
      });
    },
    getGroupMemberList(groupId) {
      let promise = tim.getGroupMemberList({
        groupID: groupId,
        count: 100,
        offset: 0,
      });
      promise
        .then(function(imResponse) {
          Store.dispatch("setCurrentGroupMenber", imResponse.data.memberList);
        })
        .catch(function(imError) {
          console.warn("getGroupMemberList error:", imError);
        });
    },
    setMessageRead() {
      // 当前会话已读上报
      let preConversationID = this.$store.getters.currentConversation
        .conversationID;
      // console.log(preConversationID)
      if (preConversationID) {
        tim.setMessageRead({ conversationID: preConversationID });
        this.$store.dispatch("clearCurrentUnread", preConversationID);
      }
      this.$store.dispatch("resetCurrentConversation");
    },
    closeChatDialog() {
      this.contactVisible = false;
      this.noticeVisible = false;
    },
    //获取复制家谱申请
    getCopyList(type) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = {
        token: loginUser.token,
        type: type,
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["copyTreeList"]["method"],
          url: apiMap["copyTreeList"]["url"],
          params: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var applyList = [];
            switch (type) {
              //别人向我申请
              case 1:
                let waitList = response.data.result.data.filter(
                  (item) => item.state == 0
                ); //抽取待我处理的申请
                waitList.forEach(function(item) {
                  applyList.push(item);
                });
                break;

              //我向别人申请
              case 2:
                let agreeList = response.data.result.data.filter(
                  (item) => item.state == 1
                ); //抽取对方同意的申请
                console.log(agreeList);
                agreeList.forEach(function(item) {
                  applyList.push(item);
                });
                break;
            }
            console.log(applyList);
            if (applyList.length > 0) {
              _this.$store.dispatch("pushCopyTreeApply", applyList);
            } else {
              _this.$store.dispatch("pushCopyTreeApply");
            }
          } else {
            _this.$store.dispatch("pushCopyTreeApply");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.message-menu li {
  position: relative;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  background-position: 13px 13px;
  background-repeat: no-repeat;
}

.menu-tip {
  display: none;
  position: absolute;
  right: 62px;
  top: 10px;
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  background-color: #ccc;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 10, 0.1);
}

.menu-tip::before {
  position: absolute;
  top: 8px;
  left: 50px;
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border: 6px dashed #f6f7f8;
  border-left-color: #ccc;
}

.message-menu li:hover {
  background-color: #fff;
}

.message-menu li:hover .menu-tip {
  display: inline-block;
}

.comment-msg {
  background-image: url("../../assets/icon/cl_chat_comments.png");
}

.notice-msg {
  background-image: url("../../assets/icon/cl_chat_notice.png");
}

.contact-msg {
  background-image: url("../../assets/icon/cl_chat_link.png");
}

.comment-msg-wrap {
  width: 100%;
}

.comment-msg-wrap .comment-msg-loading {
  height: 120px;
  text-align: center;
  background-color: #fff;
}

.no-hl-apply,
.no-syt-notice {
  text-align: center;
}

.no-hl-apply .no-msg,
.no-syt-notice .no-msg,
.comment-msg-loading .no-msg {
  position: relative;
  display: inline-block;
  margin-top: 83px;
  color: #999;
}

.no-hl-apply .no-msg::before,
.no-syt-notice .no-msg::before,
.comment-msg-loading .no-msg::before {
  position: absolute;
  top: -54px;
  left: -18px;
  width: 100px;
  height: 45px;
  content: "";
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("../../assets/image/cl_no_msg.png");
}

.hl-apply-container,
.admin-msg-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: 530px;
}

.conversation-container {
  height: 545px;
  padding: 5px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  border-right: 1px solid #e7e7e7;
}
</style>
